// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@keyframes pulse{50%{opacity:.5}}.skills-table-wrapper .is-current-sort,.skills-table-wrapper .is-sortable:hover{border-color:#ebebeb!important}@media screen and (max-width:768px){.skills-table-wrapper .b-table .table-wrapper.has-mobile-cards tr{margin-bottom:0!important}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
